import { useEffect, useState } from 'react';
import api from '../../services/api';
import Button from '../../components/Button';
import Select from '../../components/Select';

export default function BankSubmission() {
  const [runs, setRuns] = useState<any[]>([]);
  const [banks, setBanks] = useState<any[]>([]);
  const [form, setForm] = useState({ payrollRunId: '', bankId: '', format: 'NORMAL' });
  const [message, setMessage] = useState('');

  useEffect(() => {
    api.get('/payroll/runs').then((res) => setRuns(res.data.runs));
    api.get('/payroll/masters/banks').then((res) => setBanks(res.data.banks));
  }, []);

  const generate = async () => {
    if (!form.payrollRunId || !form.bankId) {
      setMessage('Select a payroll run and bank.');
      return;
    }
    try {
      const res = await api.post('/payroll/bank-submission', form, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = `bank-submission-${form.format}.csv`;
      a.click();
      setMessage('Bank submission file generated.');
    } catch (e: any) {
      setMessage('Failed to generate bank submission file.');
    }
  };

  return (
    <div className="p-6 max-w-xl">
      <h1 className="text-2xl font-bold text-gray-800 mb-4">Bank Submission</h1>
      <div className="bg-white rounded-lg shadow p-6 space-y-4">
        <Select
          label="Payroll Run"
          value={form.payrollRunId}
          onChange={(e) => setForm({ ...form, payrollRunId: e.target.value })}
          options={runs.map((r) => ({ value: r.id, label: `${r.payroll_number} — ${new Date(r.payroll_month).toISOString().slice(0, 7)}` }))}
        />
        <Select
          label="Company Bank"
          value={form.bankId}
          onChange={(e) => setForm({ ...form, bankId: e.target.value })}
          options={banks.map((b) => ({ value: b.id, label: b.name }))}
        />
        <Select
          label="Format"
          value={form.format}
          onChange={(e) => setForm({ ...form, format: e.target.value })}
          options={[
            { value: 'NORMAL', label: 'Normal Format (Summary Report)' },
            { value: 'OLD_BANK', label: 'Old Bank Format' },
            { value: 'NEW_BANK', label: 'New Bank Format' },
          ]}
        />
        <Button onClick={generate}>Generate & Download</Button>
        {message && <p className="text-sm text-gray-600">{message}</p>}
      </div>
    </div>
  );
}
